import React from 'react';
import Container from '../../../containers/integration/screenGroups/showScreenGroupContainer';

export default function () {
  return (
    <Container />
  );
}
